export enum Sizes {
  AUTO = 'AUTO',
  FILL = 'FILL',
}
